import { createAction } from 'redux-actions';
export var NAMES = {
    PLAYBACK_MODULE_LOADED: 'CLIENT.MOBILE.PLAYBACK_MODULE.LOADED',
};
export var playbackModuleLoaded = createAction(NAMES.PLAYBACK_MODULE_LOADED);
